__turbopack_context__.v({
  "list": "ContactDetails-module__9iqCGG__list" + " " + "cds-prose",
});
